import React, { Component } from 'react'

class BodyComponent extends Component {
    constructor(props) {
        super(props);

        this.currentSection = -1;
    }

    _getNextSection() {
        return (this.currentSection++);
    }

    renderNextSection() {
        this._getNextSection();
        return(<h1 ref={'h1' + this.props.links[this.currentSection]} className="underline"><div className="anchor" id={this.props.links[this.currentSection]}></div>{this.props.sections[this.currentSection]}</h1>);
    }
}

export default BodyComponent;



// WEBPACK FOOTER //
// ./src/bodycomponent.js